import { gql } from "@apollo/client";

const BRAND_LOGO = gql`
  query getBrandDetails($input: VendorProfileData!) {
    getBrandDetails(input: $input) {
      data {
        vendorDetails {
          brand {
            imageUrl
          }
        }
      }
      status
      error
    }
  }
`;
export default BRAND_LOGO;
